import React from 'react';
import { withTranslation } from 'react-i18next';
const Breadcrumbs = (props) => {
    const { t } = props;
    return (React.createElement("nav", { className: "breadcrumbs d-tl-block" },
        React.createElement("ol", { className: 'breadcrumb-list' },
            React.createElement("li", { className: 'breadcrumb-item' },
                React.createElement("a", { href: props.homeurl, className: "link-default breadcrumb-link breadcrumb-item" },
                    React.createElement("span", null, t('breadcrumb.home')))),
            React.createElement("li", { className: 'breadcrumb-item' },
                React.createElement("span", { className: "breadcrumb-active breadcrumb-item" }, props.pageactive)))));
};
export default withTranslation()(Breadcrumbs);
